import { Col, Container, Row } from "react-bootstrap"
import logo from "../../assets/logo.png";
import { UpperSection } from "./UpperSection";
import { BottomSection } from "./BottomSection";
import { createAuthenticatedAxiosInstance } from "api/auth";
import { useAuthStore } from "../../zustand/loginStore";
import { useState } from "react";
import ShippingCostsModal from "./ShippingCostsModal";

/**
 * The payment methods component
 */
export const Payments = () => {
  const { token } = useAuthStore();
  const axiosInstance = createAuthenticatedAxiosInstance(token);
  const [isUpperSection, setIsUpperSection] = useState<boolean>(false);
  const [showShippingModal, setShowShippingModal] = useState<boolean>(false);
  /**
   * Function that allows the bottom section tto load only after upper section is
   */
  const upperSectionLoaded = (isLoaded: boolean) => setIsUpperSection(isLoaded);

  return (
    <Container className="px-4 px-md-5">
      <Row className="align-items-center mb-1 mt-1">
        <Col className="text-center mt-1">
          <img src={logo} alt="Logo" style={{ width: "175px" }} />
        </Col>
      </Row>
      <Row className="align-items-center mb-4 mt-1">
        <Col className="text-center mt-1 position-relative" style={{ background: "none" }}>
          <h2 className="fw-bold">Pagos</h2>
          <button 
            className="btn btn-primary position-absolute"
            style={{ right: "0", top: "50%", transform: "translateY(-50%)" }}
            onClick={() => setShowShippingModal(true)}
          >
            Costos de envío
          </button>
        </Col>
      </Row>
      <UpperSection sectionLoaded={upperSectionLoaded} axiosInstance={axiosInstance} />
      <Row className="align-items-center mb-4 mt-1">
        <Col className="text-center mt-2">
          <h2 className="fw-bold">Métodos de pago</h2>
        </Col>
      </Row>
      <BottomSection isUpperSectionLoaded={isUpperSection} axiosInstance={axiosInstance} />
      <ShippingCostsModal
        show={showShippingModal}
        onHide={() => setShowShippingModal(false)}
        axiosInstance={axiosInstance}
      />
    </Container>
  )
}
